<template>
  <div class="review">
    <div class="d-flex flex-fill">
      <router-link :to="{ name: 'profile', params: { username: review.author.username } }">
        <profile-avatar
          :size="38"
          :username="review.author.username"
          :presetProfilePic="review.author.profilePicture"
          class="profile-avatar"
        ></profile-avatar>
      </router-link>
      <div class="review-info">
        <div class="username">
          <router-link :to="{ name: 'profile', params: { username: review.author.username } }">
            {{ review.author.username }}
          </router-link>
        </div>
        <div>
          <span class="rating"> {{ review.rating }}/10 </span>
          <span class="date-tag">{{ dateTagFromReview(review) + "  " }}</span>
          <span class="date-value">{{ formatDate(review.dateViewed || review.timePosted) }}</span>
        </div>
      </div>
    </div>
    <div class="review-text-wrapper" v-if="review.review">
      <div v-if="review.spoiler && !spoilerRevealed" class="spoiler-censor">
        <v-btn small @click="spoilerRevealed = true">Contains Spoilers</v-btn>
      </div>
      <p class="review-text">{{ review.review }}</p>
    </div>
    <router-link :to="`/review/${review.id}`" class="link-to-review">
      <v-icon>mdi-chevron-right</v-icon>
    </router-link>
  </div>
</template>

<script>
import { mediumSpecificVerbForEngaged } from "@/util/mediumHelpers";
import { formatDate } from "@/util/dateHelpers";
// eslint-disable-next-line no-unused-vars
import * as Types from "../../types/typedefs";

export default {
  name: "review-row-work-page",

  props: {
    /** @type {Types.Review} */
    review: Object,
  },

  data: () => {
    return {
      spoilerRevealed: false,
    };
  },

  methods: {
    formatDate,

    /**
     * @param {Types.Review} review
     * @returns {String}
     */
    dateTagFromReview(review) {
      if (review.dateViewed) {
        return mediumSpecificVerbForEngaged(this.review.work.medium).toLowerCase() + " on";
      } else {
        return "posted on";
      }
    },
  },
};
</script>

<style scoped>
* {
  --spoiler-blur-grow-x: 4px;
  --review-text-wrapper-margin-top: 6px;
}

.review {
  margin-top: -1px; /* Used to merge borders */
  padding: 6px 0;

  border: 1px solid var(--v-divider-darken1);
  border-left: none;
  border-right: none;

  position: relative;

  display: grid;
  grid-template-columns: 1fr min-content;
}
.review:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

div .profile-avatar {
  margin-right: 6px !important;
}
.username {
  line-height: 1;
}
.username a {
  color: var(--v-text-base) !important;
}

.link-to-review {
  display: block;
  grid-column: 3;
  grid-row: 1 / 3;
  justify-self: right;
  align-self: center;
}

.rating {
  font-weight: bold;
  font-size: 16px;
}
.date-tag {
  font-weight: normal;
  font-size: 10px;
  color: var(--v-text-lighten2);
}
.date-value {
  font-size: 12px;
  color: var(--v-text-lighten1);
}

.review-text-wrapper {
  margin-top: var(--review-text-wrapper-margin-top);
  margin-bottom: 0;
  grid-row: 2;
  height: 100%;
  width: 100%;
  position: relative;
}
.review-text {
  line-height: 1.3;
  margin-bottom: 0;
  white-space: pre-wrap;
}
.spoiler-censor {
  width: calc(100% + var(--spoiler-blur-grow-x));
  height: 100%;
  top: calc(0px - var(--review-text-wrapper-margin-top));
  left: calc(0px - var(--spoiler-blur-grow-x) / 2);
}
</style>
